import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

type CaretState = 'thinking' | 'writing';
type CaretMeta =
  | { type: 'setCaret'; pos: number; state: CaretState; label: string }
  | { type: 'clearCaret' };

export const aiCaretPluginKey = new PluginKey<DecorationSet>('aiCaret');

export function createAiCaretPlugin(caretClass: string, thinkingClass: string, writingClass: string): Plugin<DecorationSet> {
  function caretWidget(pos: number, state: CaretState, label: string): Decoration {
    return Decoration.widget(
      pos,
      () => {
        const el = document.createElement('span');
        el.className = `${caretClass} ${state === 'thinking' ? thinkingClass : writingClass}`;
        el.setAttribute('data-ai-caret', state);
        el.setAttribute('data-label', label);
        return el;
      },
      { side: 1, key: 'ai-caret', caretState: state },
    );
  }
  return new Plugin<DecorationSet>({
    key: aiCaretPluginKey,
    state: {
      init: () => DecorationSet.empty,
      apply(tr, set) {
        const next = set.map(tr.mapping, tr.doc);
        const meta = tr.getMeta(aiCaretPluginKey) as CaretMeta | undefined;
        if (!meta) return next;
        if (meta.type === 'setCaret') return DecorationSet.create(tr.doc, [caretWidget(meta.pos, meta.state, meta.label)]);
        return DecorationSet.empty;
      },
    },
    props: { decorations(state) { return aiCaretPluginKey.getState(state); } },
  });
}
